export default __webpack_public_path__ + "static/media/biopic.3884e280.jpg";